import React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import { Toaster } from 'react-hot-toast';
import { AuthProvider, useAuth } from './context/AuthContext';
import ProtectedRoute from './components/ProtectedRoute';
import Navbar from './components/Navbar';
import Sidebar from './components/Sidebar';
import Login from './pages/Login';
import Dashboard from './pages/Dashboard';
import Events from './pages/Events';
import Orders from './pages/Orders';
import Payments from './pages/Payments';
import Categories from './pages/Categories';
import Services from './pages/Services';
import Advertisements from './pages/Advertisements';
import './App.css';
import { supabase } from './utils/supabase';

const AppContent = () => {
        const { user, loading } = useAuth();
        const [isSidebarOpen, setIsSidebarOpen] = React.useState(false);

        const toggleSidebar = () => {
            setIsSidebarOpen(!isSidebarOpen);
        };

        // Supabase test query removed (no todos table in this schema).
        // Keeps login flow focused; avoids 404 noise in network panel.
        // React.useEffect(() => {
        //     async function getTodos() {
        //         const { data: todos, error } = await supabase.from('todos').select()
        //         console.log("Supabase todos fetch:", todos, error);
        //     }
        //     getTodos();
        // }, []);

        if (loading) {
            return (
                <div className="loading-container">
                    <div className="spinner" />
                    <p>Loading...</p>
                </div>
            );
        }

        if (!user) {
            return (
                <Routes>
                    <Route path="/login" element={<Login />} />
                    <Route path="*" element={<Navigate to="/login" />} />
                </Routes>
            );
        }

        return (
            <div className="app-layout">
                <Navbar toggleSidebar={toggleSidebar} />
                <div className="main-content">
                    <Sidebar isOpen={isSidebarOpen} toggleSidebar={toggleSidebar} />
                    <div className="page-content">
                        <Routes>
                            <Route path="/dashboard" element={<ProtectedRoute><Dashboard /></ProtectedRoute>} />
                            <Route path="/events" element={<ProtectedRoute><Events /></ProtectedRoute>} />
                            <Route path="/orders" element={<ProtectedRoute><Orders /></ProtectedRoute>} />
                            <Route path="/payments" element={<ProtectedRoute><Payments /></ProtectedRoute>} />
                            <Route path="/categories" element={<ProtectedRoute><Categories /></ProtectedRoute>} />
                            <Route path="/services" element={<ProtectedRoute><Services /></ProtectedRoute>} />
                            <Route path="/advertisements" element={<ProtectedRoute><Advertisements /></ProtectedRoute>} />
                            <Route path="*" element={<Navigate to="/dashboard" />} />
                        </Routes>
                    </div>
                </div>
            </div>
        );
    };

    const App = () => {
        return (
            <Router>
                <AuthProvider>
                    <Toaster position="top-right" />
                    <AppContent />
                </AuthProvider>
            </Router>
        );
    };

    export default App;